import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        --theme-accent: #00A896;
        --theme-accent-strong: #008a79;
        --theme-accent-soft: rgba(0, 168, 150, 0.1);
        --theme-primary: #0A2342;
        --theme-secondary: #334155;
        --theme-surface: #ffffff;
        --theme-surface-muted: #f8fafc;
        --theme-border: rgba(15, 23, 42, 0.1);
        --theme-hero-start: #0A2342;
        --theme-hero-end: #00A896;
        --theme-shadow-accent: rgba(0, 168, 150, 0.28);
    }

    html[data-font-size='small'] {
        font-size: 93.75%;
    }

    html[data-font-size='medium'] {
        font-size: 100%;
    }

    html[data-font-size='large'] {
        font-size: 112.5%;
    }

    body[data-theme='vvv'] {
        --theme-accent: #00A896;
        --theme-accent-strong: #008a79;
        --theme-accent-soft: rgba(0, 168, 150, 0.1);
        --theme-primary: #0A2342;
        --theme-secondary: #334155;
        --theme-hero-start: #0A2342;
        --theme-hero-end: #00A896;
        --theme-shadow-accent: rgba(0, 168, 150, 0.28);
    }

    body[data-theme='midnight'] {
        --theme-accent: #38bdf8;
        --theme-accent-strong: #0284c7;
        --theme-accent-soft: rgba(56, 189, 248, 0.12);
        --theme-primary: #0f172a;
        --theme-secondary: #334155;
        --theme-hero-start: #0f172a;
        --theme-hero-end: #1e3a8a;
        --theme-shadow-accent: rgba(56, 189, 248, 0.24);
    }

    body[data-theme='ocean'] {
        --theme-accent: #2563eb;
        --theme-accent-strong: #1d4ed8;
        --theme-accent-soft: rgba(37, 99, 235, 0.1);
        --theme-primary: #102a43;
        --theme-secondary: #334155;
        --theme-hero-start: #0f2f55;
        --theme-hero-end: #2563eb;
        --theme-shadow-accent: rgba(37, 99, 235, 0.24);
    }

    body[data-theme='cyber'] {
        --theme-accent: #7c3aed;
        --theme-accent-strong: #5b21b6;
        --theme-accent-soft: rgba(124, 58, 237, 0.1);
        --theme-primary: #1e1b4b;
        --theme-secondary: #334155;
        --theme-hero-start: #1e1b4b;
        --theme-hero-end: #7c3aed;
        --theme-shadow-accent: rgba(124, 58, 237, 0.22);
    }

    body[data-theme='forest'] {
        --theme-accent: #16a34a;
        --theme-accent-strong: #15803d;
        --theme-accent-soft: rgba(22, 163, 74, 0.1);
        --theme-primary: #10261d;
        --theme-secondary: #334155;
        --theme-hero-start: #10261d;
        --theme-hero-end: #16a34a;
        --theme-shadow-accent: rgba(22, 163, 74, 0.22);
    }

    body {
        margin: 0;
        font-family: 'Arial', sans-serif;
        background-color: #f4f4f4;
        color: var(--theme-secondary);
        transition: background-color 0.25s ease, color 0.25s ease;
    }

    * {
        box-sizing: border-box;
    }

    ::selection {
        background: var(--theme-accent-soft);
        color: var(--theme-primary);
    }
`;

export default GlobalStyles;
